import { ReactNode } from "react";

import styles from "@components/typography/Typography.module.css";

type Props = {
  children: ReactNode;
  size?: "small" | "medium" | "large";
};

const DarkButtonText = ({ children, size = "medium" }: Props) => (
  <div className={`${styles.darkButtonText} ${styles[`${size}ButtonText`]}`}>{children}</div>
);

export default DarkButtonText;
